import { ThemeContext } from "../../Contexts/ThemeContext";
import useScroll from "../../Hooks/useScroll";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Skincare = ({ showIcon }) => {
  const [linkFiveHover, setLinkFiveHover] = useState(false);
  const [scrollPosition] = useScroll();

  return (
    <div
      onMouseEnter={() => {
        setLinkFiveHover(true);
        showIcon();
      }}
      onMouseLeave={() => setLinkFiveHover(false)}
      className={`transition-all ease-in-out duration-300 min-h-[50px] flex items-center ${
        scrollPosition > 80 ? "min-h-[65px]" : ""
      }`}
    >
      <p
        className={`mr-10 block font-bold cursor-pointer ${
          scrollPosition > 80
            ? "hover:text-accent text-secondary "
            : "text-secondary hover:text-accent"
        }`}
      >
        SKINCARE
        <FontAwesomeIcon
          className="w-3 ms-2"
          icon={faChevronDown}
        ></FontAwesomeIcon>
      </p>
      <div
        className={`flex flex-col md:flex-row absolute top-10 bg-white h-[100vh] md:h-auto w-fit md:ml-[-300px] ${
          linkFiveHover ? "block text-start" : "hidden relative"
        } text-black `}
      >
        {/* ........Face CLEANSER......... */}
        <div className="px-10 py-10 pt-16 md:py-16">
          <p className="mb-6 text-black text-opacity-70">FACE CLEANSER</p>
          <Link
            to="/product-category/face wash"
            className=" hover:text-accent block"
          >
            Face wash
          </Link>
          <Link
            to="/product-category/cleansing milk"
            className=" hover:text-accent block"
          >
            Mleansing Milk
          </Link>
          <Link
            to="/product-category/cleansing gel"
            className=" hover:text-accent block"
          >
            Cleansing Gel
          </Link>

          <Link
            to="/product-category/micellar water"
            className=" hover:text-accent block"
          >
            Micellar Water
          </Link>

          <Link
            to="/product-category/soap"
            className=" hover:text-accent block"
          >
            Soap
          </Link>
        </div>

        {/* ........Moisturizer......... */}
        <div className="px-10 py-10 md:py-16">
          <p className="mb-6 text-black text-opacity-70">MOSTURIZER</p>
          <Link
            to={`/product-category/day cream`}
            className=" hover:text-accent block"
          >
            Day Cream
          </Link>

          <Link
            to={`/product-category/night cream`}
            className=" hover:text-accent block"
          >
            Night Cream
          </Link>
          <Link
            to={`/product-category/soothing gel`}
            className=" hover:text-accent block"
          >
            Soothing Gel
          </Link>
        </div>
        {/* ........Mask......... */}
        <div className="px-10 py-10 md:py-16">
          <p className="mb-6 text-black text-opacity-70">MASK</p>
          <Link
            to={`/product-category/black mask`}
            className=" hover:text-accent block"
          >
            Black Mask
          </Link>
          <Link
            to={`/product-category/clay mask`}
            className=" hover:text-accent block"
          >
            Clay Mask
          </Link>
          <Link
            to={`/product-category/gold mask`}
            className=" hover:text-accent block"
          >
            Gold Mask
          </Link>
          <Link
            to={`/product-category/peel off`}
            className=" hover:text-accent block"
          >
            Peel-Off Mask
          </Link>
        </div>
        {/* ........Toner......... */}
        <div className="px-10 py-10 md:py-16">
          <p className="mb-6 text-black text-opacity-70">TONER</p>
          <Link
            to={`/product-category/skin toner`}
            className=" hover:text-accent block"
          >
            Skin Toner
          </Link>

          <Link
            to={`/product-category/cleansing tonic`}
            className=" hover:text-accent block"
          >
            Cleansing Toner
          </Link>
        </div>
        {/* ........sun care......... */}
        <div className="px-10 py-10 md:py-16 pb-[120px]">
          <p className="mb-6 text-black text-opacity-70">SUN CARE</p>
          <Link
            to={`/product-category/sunscreen`}
            className=" hover:text-accent block"
          >
            Sunscreen
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Skincare;
